import {BuyThirdPartyComponent} from './buy-third-party/buy-third-party.component';
import {BuyBanerComponent} from './buy-baner/buy-baner.component';
import {AdvWithUsComponent} from './AdvWithUs/AdvWithUs.component';
import {NgModule} from '@angular/core';
import {Routes, RouterModule, PreloadAllModules, Router, UrlSegment, UrlSegmentGroup, Route} from '@angular/router';
import {MobileHomeComponent} from './app_mobile/views/home/home.component';
import {LoginComponent as MobileLoginComponent} from './app_mobile/views/login/login.component';
import {QuicklinkModule, QuicklinkStrategy} from 'ngx-quicklink';

import {MobileAuthGuard} from './app_mobile/components/guards/mobile-auth-guard.guard';
import {RegistrationComponent as MobileRegistrationComponent} from './app_mobile/views/registration/registration.component';
import {AccountComponent as MobileAccountComponent} from './app_mobile/views/account/account.component';
import {SearchComponent as MobileSearchComponent} from './app_mobile/views/search/search.component';
import {ResultsComponent as MobileResultsComponent} from './app_mobile/views/results/results.component';
import {AdvertisementComponent as MobileAdvertisementComponent} from './app_mobile/views/advertisement/advertisement.component';
import {ConversationComponent as MobileConversationComponent} from './app_mobile/views/conversation/conversation.component';
import {SubscribtionComponent as MobileSubscribtionComponent} from './app_mobile/views/subscribtion/subscribtion.component';
import {SubscriptionInformationComponent as MobileSubscriptionInformationComponent} from './app_mobile/views/subscription-information/subscription-information.component';
import {SubscribtionConfirmComponent as MobileSubscribtionConfirmComponent} from './app_mobile/views/subscription-confirm/subscription-confirm.component';
import {UserAdvertisementsComponent as MobileUserAdvertisementsComponent} from './app_mobile/views/user-advertisements/user-advertisements.component';
import {AdvEditComponent as MobileAdvEditComponent} from './app_mobile/views/advertisement-edit/advertisement-edit.component';
import {NonDemoAdsComponent as MobileNonDemoAdsComponent} from './app_mobile/views/non-demo-ads/non-demo-ads.component';
import {RouteSeachResults as MobileRouteSeachResults} from './app_mobile/components/route-search-results/route-search-results.component';
import {MobileAdWritterComponent} from './app_mobile/views/AdWritter/AdWritter.component';
import {MobileBuyThirdPartyComponent} from './app_mobile/views/buy-third-party/buy-third-party.component';

import {PageNotFoundComponent} from './Pages/page-not-found/page-not-found.component';
import {Over18Guard} from './Guards/over18-guard.guard';
import {HelpAndFaqComponent} from './Cms/help-and-faq/help-and-faq.component';
import {TermOfUseComponent} from './Cms/term-of-use/term-of-use.component';
import {PrivacyPolicyComponent} from './Cms/privacy-policy/privacy-policy.component';
import {DatingTipsComponent} from './Cms/dating-tips/dating-tips.component';
import {AdvertiseWithUsComponent} from './Cms/advertise-with-us/advertise-with-us.component';
import {CompareVersionsPageComponent} from './Cms/compare-versions/compare-versions.component';
import {MobileCompareVersionsPageComponent} from './app_mobile/components/compare-versions/compare-versions.component';
import {AuthGuard} from './Guards/auth-guard.guard';
import {AboutUsComponent} from './Cms/about-us/about-us.component';
import {ContactUsComponent} from './Cms/contact-us/contact-us.component';
import {EmptyPageComponent} from './Pages/empty-page/empty-page.component';
import {FetchDataComponent} from './fetch-data/fetch-data.component';
import {CounterComponent} from './counter/counter.component';
import {AdvEditComponent} from './Adveristments/adv-edit/adv-edit.component';
import {AdvManageComponent} from './Adveristments/adv-manage/adv-manage.component';
import {ResetPasswordHolderComponent} from './User/reset-password-holder/reset-password-holder.component';
import {NewPasswordHolderComponent} from './User/new-password-holder/new-password-holder.component';
import {ValidatePhoneHolderComponent} from './User/validate-phone-holder/validate-phone-holder.component';
import {ValidateEmailComponent} from './User/validate-email/validate-email.component';
import {RegistrationSuccessComponent} from './User/registration-success/registration-success.component';
import {RegistrationHolderComponent} from './User/registration-holder/registration-holder.component';
import {ConversationsListComponent} from './Conversations/conv-list/conv-list.component';
import {AdWritterComponent} from './AdWritter/AdWritter.component';
import {AdvUserAdvertisementsComponent} from './Adveristments/adv-user-advertisements/adv-user-advertisements.component';
import {AdvUserMessagesComponent} from './Adveristments/adv-user-messages/adv-user-messages.component';
import {AdvDetailComponent} from './Adveristments/adv-detail/adv-detail.component';
import {SearchResultsComponent} from './Adv/search-results/search-results.component';
import {SubscribtionConfirmComponent} from './SubscriptionConfirm/SubscribtionConfirm.component';
import {MainWindowComponent} from './main-window/main-window.component';
import {SubscriptionInformationComponent} from './SubscriptionInformation/subscriptionInformation.component';
import {SubscribtionComponent} from './Subscribtion/subscribtion.component';
import isMobile from "is-mobile";
import {HomeComponent} from './home/home.component';
import {AdvUserAdvertisementsNonDemoComponent} from './Adveristments/adv-user-advertisements-non-demo/adv-user-advertisements-non-demo.component';
import {RouteSeachResults} from './Adv/route-search-results/route-search-results.component';
import {RegexSearchList, RegexCategory, RegexCity, RegexSearchResults} from './Services/searchroute.service';
import {environment} from '../environments/environment';
import {ActionGuard} from './Guards/action.guard';

export function urlMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return matchHelper(segments, RegexSearchList);
}
export function urlCategoryMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return matchHelper(segments, RegexCategory);
}
export function urlCityMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return matchHelper(segments, RegexCity);
}
export function urlSearchResultsMatcher(segments: UrlSegment[], group: UrlSegmentGroup, route: Route) {
  return matchHelper(segments, RegexSearchResults);
}


const matchHelper = (segments, regExpresion) => {
  let regex = new RegExp(regExpresion, "gi");
  var regexMatch = regex.exec(segments[0].path);
  if(regexMatch != null && (regexMatch as any).groups != null) {
    let posParams: {[key: string]: UrlSegment} = {};

    Object.keys((regexMatch as any).groups).forEach(key => {
      posParams[key] = new UrlSegment((regexMatch as any).groups[key], {});
    });
    return {
      consumed: segments,
      posParams: posParams
    };
  }
  return null;
}

const desktopRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [Over18Guard, ActionGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "city/:cityId",
    component: HomeComponent,
    canActivate: [Over18Guard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "subscription",
    component: SubscribtionComponent,
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "subscription-information",
    component: SubscriptionInformationComponent,
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "subscription-confirm",
    component: SubscribtionConfirmComponent,
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "main",
    component: MainWindowComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "search-results",
    component: SearchResultsComponent,
    pathMatch: "full",
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always",
  },
  {
    component: SearchResultsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always",
    matcher: urlSearchResultsMatcher
  },
  {
    path: "search-results/:casualDating/:relationShip/:withPicture/:state/:city",
    component: SearchResultsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-detail/:code/:locationData",
    component: AdvDetailComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-detail/:code/c/:conversationKey",
    component: AdvDetailComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-detail/:code",
    component: AdvDetailComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "messages",
    component: AdvUserMessagesComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "my-ads",
    component: AdvUserAdvertisementsComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "non-demo-ads",
    component: AdvUserAdvertisementsNonDemoComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "ad-writter",
    component: AdWritterComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "conversations",
    component: ConversationsListComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "conversations/:id",
    component: ConversationsListComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "register",
    component: RegistrationHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "register"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "registration-success",
    component: RegistrationSuccessComponent,
    canActivate: [Over18Guard],
    data: {animation: "registration-success"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "validate-email/:code",
    component: ValidateEmailComponent,
    canActivate: [Over18Guard],
    data: {animation: "validate-email"}
  },
  {
    path: "validate-phone/:user_data",
    component: ValidatePhoneHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "validate-phone"}
  },
  {
    path: "new-password/:code",
    component: NewPasswordHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "new-password"}
  },
  {
    path: "reset-password",
    component: ResetPasswordHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "reset-password"}
  },
  {
    path: "adv-edit/:id",
    component: AdvEditComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "adv-edit"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-manage/:manage-id",
    component: AdvManageComponent,
    canActivate: [Over18Guard],
    data: {animation: "adv-manage"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-create",
    component: AdvEditComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "adv-create"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-with-us",
    component: AdvWithUsComponent,
    data: {animation: "adv-with-us"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "buy-baner",
    component: BuyBanerComponent,
    data: {animation: "buy-baner"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "buy-third-party",
    component: BuyThirdPartyComponent,
    data: {animation: "buy-third-party", isMobile: false},
    runGuardsAndResolvers: "always"
  },
  //NewPasswordComponent
  //ValidateEmailComponent
  {
    path: "counter",
    component: CounterComponent,
    canActivate: [AuthGuard, Over18Guard],
    data: {animation: "counter"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "fetch-data",
    component: FetchDataComponent,
    canActivate: [Over18Guard],
    data: {animation: "fetch-data"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "empty",
    component: EmptyPageComponent,
    data: {animation: "empty"}
  },
  /////CMS ITEMS
  {
    path: "contact-us",
    component: ContactUsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "about-us",
    component: AboutUsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "compare-versions",
    component: CompareVersionsPageComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "advertise-with-us",
    component: AdvertiseWithUsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "dating-tips",
    component: DatingTipsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "terms-of-use",
    component: TermOfUseComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "help-and-faq",
    component: HelpAndFaqComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    component: RouteSeachResults,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlMatcher
  },
  {
    component: HomeComponent,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlCategoryMatcher
  },
  {
    component: HomeComponent,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlCityMatcher
  },
  {path: "**", component: PageNotFoundComponent}
];



const mobileRoutes: Routes = [
  {
    path: '',
    component: MobileHomeComponent,
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'login',
    component: MobileLoginComponent,
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'register',
    component: MobileRegistrationComponent,
    //loadChildren: () => import('./app_mobile/views/registration/registration.component').then(m => m.RegistrationComponent),
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },

  {
    path: "registration-success",
    component: RegistrationSuccessComponent,
    canActivate: [Over18Guard],
    data: {animation: "registration-success"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "validate-email/:code",
    component: ValidateEmailComponent,
    canActivate: [Over18Guard],
    data: {animation: "validate-email"}
  },
  {
    path: "validate-phone/:user_data",
    component: ValidatePhoneHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "validate-phone"}
  },
  {
    path: "new-password/:code",
    component: NewPasswordHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "new-password"}
  },
  {
    path: "reset-password",
    component: ResetPasswordHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "reset-password"}
  },
  {
    path: 'account',
    component: MobileAccountComponent,
    //loadChildren: () => import('./app_mobile/views/account/account.component').then(m => m.AccountComponent),
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'search',
    component: MobileSearchComponent,
    //loadChildren: () => import('./app_mobile/views/search/search.component').then(m => m.SearchComponent),
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: "search-results",
    component: MobileResultsComponent,
    pathMatch: "full",
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "search-results/:casualDating/:relationShip/:withPicture/:state/:city",
    component: MobileResultsComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-detail/:code/:locationData",
    component: MobileAdvertisementComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-detail/:code/c/:conversationKey",
    component: MobileAdvertisementComponent,
    canActivate: [Over18Guard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: 'adv-detail/:code',
    component: MobileAdvertisementComponent,
    //loadChildren: () => import('./app_mobile/views/advertisement/advertisement.component').then(m => m.AdvertisementComponent),
    canActivate: [Over18Guard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'conversations',
    component: MobileConversationComponent,
    //loadChildren: () => import('./app_mobile/views/conversation/conversation.component').then(m => m.ConversationComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'conversations/:id',
    component: MobileConversationComponent,
    //loadChildren: () => import('./app_mobile/views/conversation/conversation.component').then(m => m.ConversationComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'subscription',
    component: MobileSubscribtionComponent,
    //loadChildren: () => import('./app_mobile/views/subscribtion/subscribtion.component').then(m => m.SubscribtionComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: "subscription-information",
    component: MobileSubscriptionInformationComponent,
    //loadChildren: () => import('./app_mobile/views/subscription-information/subscription-information.component').then(m => m.SubscriptionInformationComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: "subscription-confirm",
    component: MobileSubscribtionConfirmComponent,
    //loadChildren: () => import('./app_mobile/views/subscription-confirm/subscription-confirm.component').then(m => m.SubscribtionConfirmComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: "full",
    runGuardsAndResolvers: "always"
  },
  {
    path: 'my-ads',
    component: MobileUserAdvertisementsComponent,
    //loadChildren: () => import('./app_mobile/views/user-advertisements/user-advertisements.component').then(m => m.UserAdvertisementsComponent),
    canActivate: [Over18Guard, AuthGuard],
    pathMatch: 'full',
    runGuardsAndResolvers: 'always'
  },
  {
    path: "adv-edit/:id",
    component: MobileAdvEditComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "adv-edit"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-create",
    component: MobileAdvEditComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "adv-create"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "compare-versions",
    component: MobileCompareVersionsPageComponent,
    canActivate: [Over18Guard, MobileAuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "non-demo-ads",
    component: MobileNonDemoAdsComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "ad-writter",
    component: MobileAdWritterComponent,
    canActivate: [Over18Guard, AuthGuard],
    data: {animation: "main"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "adv-with-us",
    component: AdvWithUsComponent,
    canActivate: [Over18Guard],
    data: {animation: "adv-with-us"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "buy-baner",
    component: BuyBanerComponent,
    canActivate: [Over18Guard],
    data: {animation: "buy-baner"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "buy-third-party",
    component: MobileBuyThirdPartyComponent,
    canActivate: [Over18Guard],
    data: {animation: "buy-third-party"},
    runGuardsAndResolvers: "always"
  },
  {
    path: "reset-password",
    component: ResetPasswordHolderComponent,
    canActivate: [Over18Guard],
    data: {animation: "reset-password"}
  },
  {
    component: MobileRouteSeachResults,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlMatcher
  },
  {
    component: MobileHomeComponent,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlCategoryMatcher
  },
  {
    component: MobileHomeComponent,
    canActivate: [Over18Guard],
    runGuardsAndResolvers: "always",
    matcher: urlCityMatcher
  },
  {path: "**", component: PageNotFoundComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(desktopRoutes, {preloadingStrategy: PreloadAllModules, useHash: environment.name == "CORDOVA"})],
  exports: [RouterModule]
})
export class AppRoutingModule {
  public constructor(private router: Router) {

    if(isMobile()) {
      router.resetConfig(mobileRoutes);

    }
  }
}
